// Sticky blog sidebar ([data-sticky-sidebar], lg:sticky in the markup).
// A sidebar shorter than the window sticks 32px from the top. One taller than
// the window gets a negative top, so it scrolls with the article until its
// bottom is in view and sticks there, instead of hiding its lower panels.
const GAP = 32;

function place(el) {
  el.style.top = Math.min(GAP, window.innerHeight - el.offsetHeight - GAP) + 'px';
}

document.querySelectorAll('[data-sticky-sidebar]').forEach((el) => {
  place(el);
  window.addEventListener('resize', () => place(el), { passive: true });
  // Images and fonts loading after first paint change its height
  if ('ResizeObserver' in window) {
    new ResizeObserver(() => place(el)).observe(el);
  }
});
